import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import Timeline from './components/Timeline';
import Admin from './components/Admin';
import Guestbook from './components/Guestbook';
import WriteWish from './components/WriteWish';
import Trivia from './components/Trivia';
import Reasons from './components/Reasons';
import GiftBox from './components/GiftBox';
import Vault from './components/Vault';
import './App.css';

// We wrap the inner app content so we can use the useLocation hook safely
function AppContent({ isUnwrapped, setIsUnwrapped }) {
  const location = useLocation();
  
  // FIXED: Now ONLY hides the navigation menu on the public '/write' page
  const hideNavigation = location.pathname === '/write';

  // If Koralie hasn't unwrapped her gift AND the user isn't on the hidden write path, show the landing box
  if (!isUnwrapped && !hideNavigation) {
    return <GiftBox onOpen={() => setIsUnwrapped(true)} />;
  }

  return (
    <div className="App">
      {/* SIDE/BOTTOM NAVIGATION BAR - Visible on Trivia now! */}
      {!hideNavigation && (
        <nav className="navbar">
          <div className="nav-container">
            <NavLink to="/" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              📖 Story
            </NavLink>
            <NavLink to="/reasons" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              ❤️ 25 Reasons
            </NavLink>
            <NavLink to="/vault" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              🔓 Vault
            </NavLink>
            <NavLink to="/wishes" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              💌 Wishes
            </NavLink>
            <NavLink to="/trivia" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
              ❓ Trivia
            </NavLink>
          </div>
        </nav>
      )}

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Timeline />} />
        <Route path="/reasons" element={<Reasons />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/wishes" element={<Guestbook />} />
        <Route path="/trivia" element={<Trivia />} />
        <Route path="/write" element={<WriteWish />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </div>
  );
}

function App() {
  const [isUnwrapped, setIsUnwrapped] = useState(false);

  return (
    <Router>
      <AppContent isUnwrapped={isUnwrapped} setIsUnwrapped={setIsUnwrapped} />
    </Router>
  );
}

export default App;